<template>
  <!-- 統計表作成実行 -->
  <ModalDialog
    pop-name="統計表作成実行"
    dialog-width="600px"
    dialog-height="auto"
    margin-class="mtp-3 mbm-3"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div class="d-flex mtp-3" style="justify-content: center">
        <div>
          過去に修正されたデータは破棄され、仮登録から再実行となります。
        </div>
      </div>
    </template>

    <template #footer>
      <div class="d-flex justify-content-center">
        <ButtonMain button-name="実行"></ButtonMain>
        <ButtonNormal
          class="ms-4"
          button-name="キャンセル"
          @click="cancel"
        ></ButtonNormal>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'ExecutionDialog',
  data() {
    return {}
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss"></style>
